import type { ReactElement } from 'react';
import { SKELETON_CYCLE, skeletonLine } from '@/components/ui/skeleton';

const ROWS = 6;

/** Skeleton con la forma de la tabla del catálogo (UX-LOAD-01): una fila por
 *  elemento con su código, nombre y estado. Nunca un spinner genérico. */
export function CatalogSkeleton(): ReactElement {
  return (
    <div
      className="card rise"
      data-testid="catalog-skeleton"
      aria-busy="true"
      aria-label="Cargando catálogo"
    >
      <div className="cb">
        {Array.from({ length: ROWS }, (_, i) => (
          <div
            key={i}
            style={{
              display: 'grid',
              gridTemplateColumns: '56px 1fr 72px',
              gap: 16,
              padding: '10px 0',
            }}
          >
            <div className="skeleton-line" />
            <div className={skeletonLine({ width: SKELETON_CYCLE[i % SKELETON_CYCLE.length] })} />
            <div className="skeleton-line" />
          </div>
        ))}
      </div>
    </div>
  );
}
